import moment from 'moment';
import 'moment/locale/ru';

moment.locale('ru');

export const days = [
  { label: "-", value: "none" }, 
  ...Array.from({ length: moment().daysInMonth() }, (_, i) => ({
    label: (i + 1).toString(),
    value: i + 1,
  })),
];

export const months = [
  { label: "-", value: "none" }, 
  ...moment.months().map((month, index) => ({
    label: month,
    value: index + 1,
  })),
];

const currentYear = moment().year();

export const years = [
  { label: "-", value: "none" }, 
  ...Array.from({ length: currentYear - 1800 + 1 }, (_, i) => ({
    label: moment().year() - i,
    value: moment().year() - i,
  })),
];


// Моки для уведомлений
export const notificationsMocks = [
  {
    name: "Таиса Понтелеевна (Тася)",
    user: "User#3",
    type: "Трибьюты",
    date: "08.10.2024"
  },
  {
    name: "Таиса Понтелеевна (Тася)",
    user: "User#3",
    type: "Воспоминания",
    date: "08.10.2024"
  },
  {
    name: "Таиса Понтелеевна (Тася)",
    user: "User#3",
    type: "Трибьюты",
    date: "08.10.2024"
  },
  {
    name: "Таиса Понтелеевна (Тася)",
    user: "User#3",
    type: "Трибьюты",
    date: "08.10.2024"
  },
  {
    name: "Таиса Понтелеевна (Тася)",
    user: "User#3",
    type: "Воспоминания",
    date: "08.10.2024"
  },
  {
    name: "Таиса Понтелеевна (Тася)",
    user: "User#3",
    type: "Воспоминания",
    date: "08.10.2024"
  },
  {
    name: "Таиса Понтелеевна (Тася)",
    user: "User#3",
    type: "Воспоминания",
    date: "08.10.2024"
  },
  {
    name: "Таиса Понтелеевна (Тася)",
    user: "User#3",
    type: "Воспоминания",
    date: "08.10.2024"
  }
]